import { render, staticRenderFns } from "./AGlassColorSelector.vue?vue&type=template&id=4cde7d08&"
import script from "./AGlassColorSelector.vue?vue&type=script&lang=js&"
export * from "./AGlassColorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports